import {LoginPage, countryHelper} from './pages/login';
import {PasscodePage} from './pages/passcode';
import {PasswordPage} from './pages/password';
import {NewUserPage} from './pages/new';
import {BasePage} from './utils/base';
import {Store} from './utils/store';
import {ChatsPage} from './pages/chats';
import './css/index.scss';
import {formatPhone, findPhoneNumber, findCountry, findPhonePrefix} from './utils/helper';

export enum Pages {
  LOGIN = 'login',
  PASSCODE = 'passcode',
  PASSWORD = 'password',
  NEW_USER = 'new_user',
  CHATS = 'chats',
}

class App extends BasePage {
  constructor() {
    super();

    // this.openPage(Pages.NEW_USER);
    // return;

    this.storeHelper.subscribe(['authState'], (store: Store) => {
      let authState = store.authState;
      let type = authState ? authState['@type'] : '';

      if (type === 'authorizationStateClosed') {
        this.app.innerHTML = '';
        window.location.reload();
      } else if (type === 'authorizationStateWaitPhoneNumber') {
        this.openPage(Pages.LOGIN);
      } else if (type === 'authorizationStateWaitCode') {
        localStorage.setItem('logout', '0');

        let rawPhoneNumber = authState['code_info']['phone_number'];
        let phonePrefix = findPhonePrefix(rawPhoneNumber, undefined, countryHelper);
        let selectedCountry = findCountry(phonePrefix, undefined, countryHelper);
        let phoneNumber = findPhoneNumber(rawPhoneNumber, phonePrefix);

        this.storeHelper.setStore({phonePrefix, selectedCountry, phoneNumber: formatPhone(phoneNumber)});

        this.openPage(Pages.PASSCODE);
      } else if (type === 'authorizationStateWaitRegistration') {
        this.openPage(Pages.NEW_USER);
      } else if (type === 'authorizationStateWaitPassword') {
        this.openPage(Pages.PASSWORD);
      } else if (type === 'authorizationStateReady') {
        if (localStorage.getItem('logout') === '1') {
          localStorage.setItem('logout', '0');
          this.apiHelper.logOut();
          return;
        }

        this.openPage(Pages.CHATS);
      }
    });
  }

  openPage = (page: Pages) => {
    if (page === Pages.LOGIN) {
      new LoginPage();
    } else if (page === Pages.PASSCODE) {
      new PasscodePage(this.openPage);
    } else if (page === Pages.PASSWORD) {
      new PasswordPage();
    } else if (page === Pages.NEW_USER) {
      new NewUserPage();
    } else if (page === Pages.CHATS) {
      new ChatsPage();
    }
  };
}

new App();
